<div class="mb-3">
  <h6 class="mb-0" i18n>Subscribed Applications</h6>
</div>
<div class="container-box addons-table-holder" data-intercom-subscribed-apps>
  <div class="p-3 d-flex">
    <app-table-search (search)="onSearch($event)"></app-table-search>
  </div>
  <div class="table-holder table-responsive">
    <table class="table table-default table-striped sortable" #table>
      <thead>
        <tr>
          <th i18n>Application name</th>
          <th i18n>when subscription started</th>
          <th i18n>Next Payment date</th>
          <th i18n class="no-sort">payment total</th>
          <th i18n class="no-sort">Status</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="subscriptionsLoading$ | async">
          <tr>
            <td></td>
            <td></td>
            <td>
              <app-loading-section></app-loading-section>
            </td>
            <td></td>
            <td></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!(subscriptionsLoading$ | async)">
          <tr *ngFor="let subscription of subscriptions$ | async">
            <td>
              <ng-container *ngIf="(apps$ | async)[subscription.product]; let app; else: noApps">
                <ng-container *ngIf="subscription.product === 'tokeet'; else otherApp">
                  <img src="/assets/logo.svg" alt="AdvanceCM" class="addons-img" />
                  AdvanceCM
                </ng-container>
                <ng-template #otherApp>
                  <img [src]="app?.logo_url" alt="App Logo" class="addons-img" />
                  {{ app?.name }}
                </ng-template>
              </ng-container>
              <ng-template #noApps>
                <img src="/assets/logo.svg" alt="App Logo" class="addons-img" />
                {{ subscription.product === 'papi' ? 'Partner API' : subscription.planName }}
              </ng-template>
            </td>
            <td [attr.data-sort]="subscription.start">
              <fa-icon [icon]="['fal', 'alarm-clock']" class="icon-danger"></fa-icon>
              {{ subscription.start | epoch }}
              <span *ngIf="isOverdue | call : subscription.until" class="due-date" i18n>1 Day Overdue</span>
            </td>
            <td [class.has-trial]="subscription.status === 'trialing'" [attr.data-sort]="subscription.until">
              <ng-container *ngIf="subscription.status === 'trialing'">
                <span i18n>Trial until: </span>{{ subscription.trialEnd | epoch }}
              </ng-container>
              <ng-container *ngIf="subscription.status !== 'trialing'">
                {{ subscription.until | epoch }}
              </ng-container>
            </td>
            <td>
              <ng-container [ngSwitch]="subscription.product">
                <ng-container *ngSwitchCase="'tokeet_ai'" i18n> $0.02 per generated response </ng-container>
                <ng-container *ngSwitchCase="'power_reporting'">
                  ${{ roundFloat | call : subscription.price * subscription.quantity }}
                </ng-container>
                <ng-container *ngSwitchCase="'papi'">
                  ${{ roundFloat | call : subscription.price * subscription.quantity }}
                </ng-container>
                <ng-container *ngSwitchCase="'tokeet_smart_devices'">
                  ${{ roundFloat | call : subscription.price * subscription.quantity }}
                  <ng-container i18n>for</ng-container> {{ subscription.quantity }}
                  <ng-container i18n>device(s) per month</ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'rategenie'">
                  <ng-container *ngIf="!subscription.discount"> {{ rgPrice$ | async | currency }} </ng-container>
                  <ng-container *ngIf="!!subscription.discount">
                    {{ (rgPrice$ | async) - (rgPrice$ | async) * (subscription.discount.percent_off / 100) | currency }}
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  ${{ roundFloat | call : (getDisplayPrice | call : subscription) }}
                </ng-container>
              </ng-container>
              {{ getSubscriptionPriceUnit | call : 'flat' : (isYearly | call : subscription) }}
            </td>
            <td
              *ngIf="
                subscription.product !== 'webready' &&
                subscription.product !== 'tokeet' &&
                subscription.product !== 'website_management'
              "
              (click)="$event.stopPropagation()"
              class="status-column"
            >
              <div class="d-flex align-items-center">
                <app-form-switch
                  [inline]="true"
                  [value]="isActive | call : subscription"
                  (valueChange)="onStatusChange($event, subscription)"
                  matTooltip="Cancel subscription for this app"
                  matTooltipPosition="left"
                  i18n-matTooltip
                ></app-form-switch>
                <div class="status">
                  {{ getStatus | call : subscription }}
                </div>
              </div>
              <div *ngIf="subscription.cancelAtPeriodEnd" class="valid-until">
                <ng-container i18n>Valid until:</ng-container> {{ subscription.until | epoch }}
              </div>
            </td>
            <td
              *ngIf="subscription.product === 'tokeet' || subscription.product === 'website_management'"
              (mouseenter)="subscription.$hideToggle = true"
              (mouseleave)="subscription.$hideToggle = false"
              class="status-column"
            >
              <div class="d-flex align-items-center">
                <ng-container *ngIf="!subscription?.$hideToggle">
                  <app-form-switch [inline]="true" [value]="true"></app-form-switch>
                  <span class="status" i18n>Active</span>
                </ng-container>
                <ng-container *ngIf="subscription?.$hideToggle">
                  <span class="webready-status" i18n>Please contact support to cancel</span>
                </ng-container>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="webreadySubscription$ | async as subscription">
            <ng-container *ngIf="subscription.tier === 'unlimited'">
              <tr>
                <td>
                  <img
                    [src]="geWebreadyLogo(apps$, 'single_rental_website') | async"
                    alt="App Logo"
                    class="addons-img"
                  />
                  <ng-container i18n>Webready Unlimited</ng-container>
                </td>
                <td [attr.data-sort]="subscription.created">
                  <fa-icon [icon]="['fal', 'alarm-clock']" class="icon-danger"></fa-icon>
                  {{ subscription.created | epoch }}
                  <span *ngIf="isOverdue | call : subscription.current_period_end" class="due-date" i18n
                    >1 Day Overdue</span
                  >
                </td>
                <td [attr.data-sort]="subscription.current_period_end">
                  {{ subscription.current_period_end | epoch }}
                </td>
                <td i18n>$499.00 per month</td>
                <td class="status-column">
                  <span class="webready-status" i18n>Please reach out to support for updates</span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="subscription.tier !== 'unlimited'">
              <tr *ngFor="let sub of subscription.features | keyvalue">
                <td>
                  <img [src]="geWebreadyLogo(apps$, sub.key) | async" alt="App Logo" class="addons-img" />
                  {{ sub.value.name }}
                </td>
                <td [attr.data-sort]="subscription.created">
                  <fa-icon [icon]="['fal', 'alarm-clock']" class="icon-danger"></fa-icon>
                  {{ subscription.created | epoch }}
                  <span *ngIf="isOverdue | call : subscription.current_period_end" class="due-date" i18n
                    >1 Day Overdue</span
                  >
                </td>
                <td [attr.data-sort]="subscription.current_period_end">
                  {{ subscription.current_period_end | epoch }}
                </td>
                <td>
                  {{ getCharge | call : sub.key : sub.value }}
                </td>
                <td
                  *ngIf="!isWebreadyAddon(sub.key)"
                  (mouseenter)="sub.$hideToggle = true"
                  (mouseleave)="sub.$hideToggle = false"
                  class="status-column"
                >
                  <ng-container *ngIf="!sub.$hideToggle">
                    <div class="d-flex align-items-center">
                      <app-form-switch [inline]="true" [value]="isActive | call : subscription"></app-form-switch>
                      <div class="status">
                        {{ getWebreadyStatus | call : subscription }}
                      </div>
                    </div>
                    <div *ngIf="subscription.cancelAtPeriodEnd" class="valid-until">
                      <ng-container i18n>Valid until:</ng-container> {{ subscription.current_period_end | epoch }}
                    </div>
                  </ng-container>
                  <ng-container *ngIf="sub.$hideToggle">
                    <span class="webready-status" i18n>Can only be updated on Webready app</span>
                  </ng-container>
                </td>
                <td *ngIf="isWebreadyAddon(sub.key)" (click)="$event.stopPropagation()" class="status-column">
                  <div class="d-flex align-items-center">
                    <app-form-switch
                      [value]="isActiveWebreadyAddon | call : subscription : sub.key"
                      (valueChange)="onWebreadyAddonStatusChange($event, sub.key)"
                      [inline]="true"
                    ></app-form-switch>
                    <div *ngIf="unsubscribingWebreadyAddons === sub.key" class="unsubscribing">
                      <fa-icon [icon]="['fal', 'spinner']" [spin]="true" [size]="'2x'"></fa-icon>
                    </div>
                    <div *ngIf="unsubscribingWebreadyAddons !== sub.key" class="status">
                      {{ getStatusWebreadyAddon | call : subscription : sub.key }}
                    </div>
                  </div>
                  <div
                    *ngIf="
                      subscription.cancelAtPeriodEnd ||
                      (!!subscription.next_billing_cycle &&
                        !(subscription.next_billing_cycle?.features)[sub.key]?.active)
                    "
                    class="valid-until"
                  >
                    <ng-container i18n>Valid until:</ng-container> {{ subscription.current_period_end | epoch }}
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
